import { compose, createSelector } from '@reduxjs/toolkit';

import { type TJsonQuery, insertPageToJsonQuery, insertSortToJsonQuery } from '@/packages/JsonQuery';

import { useReduxSelector } from '../../../hooks';
import { type TReduxState } from '../../../types';
import { activePinPageSelector, activePinSortSelector } from '../../mapControls/selectors/dumb';

import { filtersSelector, listingSortSelector, pageSelector } from './dumb';

export const completeJsonQueryByPinSelector = createSelector(
  [filtersSelector, activePinSortSelector, activePinPageSelector],
  (filters, sort, page) => {
    return compose(insertPageToJsonQuery(page), insertSortToJsonQuery(sort))(filters);
  },
);

export function useCompleteJsonQueryByPinSelector(): TJsonQuery {
  return useReduxSelector(completeJsonQueryByPinSelector);
}

export const completeSimilarOffersJsonQuerySelector = createSelector(
  [filtersSelector, (_state: TReduxState, page: number | undefined): number | undefined => page],
  (filters, page) => {
    return compose(insertPageToJsonQuery(page))(filters);
  },
);

export const completeClustersJsonQuerySelector = createSelector(
  [filtersSelector, listingSortSelector, pageSelector],
  (filters, sort, page) => {
    return compose(insertPageToJsonQuery(page), insertSortToJsonQuery(sort))(filters);
  },
);
